import { render, staticRenderFns } from "./manifest.vue?vue&type=template&id=9383a4c6&scoped=true"
import script from "./manifest.vue?vue&type=script&lang=js"
export * from "./manifest.vue?vue&type=script&lang=js"
import style0 from "./manifest.vue?vue&type=style&index=0&id=9383a4c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9383a4c6",
  null
  
)

export default component.exports